export default __webpack_public_path__ + "static/media/login-logo.ad5eba37.png";